module.exports = require("lodash/assign");